import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import dayjs from "dayjs";
import HorizontalBarChart from "./HorizontalBarChart";
import AreaChart from "./AreaChart";
import ImagesHorizontalBar from "./ImagesHorizontalBar";
import ImagesBarChart from "./ImagesHorizontalBar";
import { toast } from "react-toastify";
import PieChart from "./PieChart";
import DonutChart from "./DonutsChart";
import LineChart from "./LineChart";

export default function Analytics(props) {
    const [dateFrom, setDateFrom] = useState(dayjs().startOf('month').startOf('day'));
    const [dateTo, setDateTo] = useState(dayjs().endOf("day").endOf('month'));
    const [totalRegistration, setTotalRegistration] = useState(0)
    const [datasetShippingPlayers, setDatasetShippingPlayers] = useState({ labels: [], datasets: [], total: 0 });
    const [datasetShippedItems, setDatasetShippedItems] = useState({ labels: [], datasets: [], total: 0 });
    const [datasetNewPlayers, setDatasetNewPlayers] = useState({ labels: [], datasets: [], total: 0 });
    const [datasetUsersPlayed, setDatasetUsersPlayed] = useState({ labels: [], datasets: [], total: 0 });
    const [datasetAvgPlayers, setDatasetAvgPlayers] = useState({ labels: [], datasets: [], total: 0 });
    const [datasetEditionsType, setDatasetEditionsType] = useState({ labels: [], datasets: [], total: 0 });
    const [datasetUserEditions, setDatasetUserEditions] = useState({ labels: [], datasets: [], total: 0 });
    const [datasetUserPlayPercentage, setDatasetUserPlayPercentage] = useState({ labels: [], datasets: [], total: 0 });
    const [datasetItem, setDatasetItem] = useState({ labels: [], datasets: [], total: 0 });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getData();
    }, [dateFrom, dateTo]);

    const getData = async () => {
        setLoading(true);
        try {
            axios.defaults.headers.common["jwt"] = sessionStorage.getItem("val");
            const body = {
                startDate: dateFrom.format("YYYY-MM-DDTHH:mm"),
                endDate: dateTo.format("YYYY-MM-DDTHH:mm"),
            };
            const response = await axios.post(
                `${sessionStorage.getItem("env")}/survivor/api/v1/Admin/getAnalytics`,
                body
            );
            const labels0 = response.data.response.newPlayers?.map((el) => el.day);
            const values0 = response.data.response.newPlayers?.map((el) => el.total);
            const total0 = values0?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

            const labels1 = response.data.response.usersPlayed?.daily.map((el) => el.day);
            const values1 = response.data.response.usersPlayed?.daily.map((el) => el.total);
            const total1 = response.data.response.usersPlayed?.totalPeriod

            const labels2 = response.data.response.shippingPlayers?.daily.map((el) => el.day);
            const values2 = response.data.response.shippingPlayers?.daily.map((el) => el.total);
            const total2 = response.data.response.shippingPlayers?.totalPeriod

            const labels3 = response.data.response.shippedItems?.map((el) => el.item.replace('com.omo.survivor.', ''));
            const values3 = response.data.response.shippedItems?.map((el) => el.total);
            const total3 = values3?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

            const labels4 = response.data.response.averagePlayers?.map((el) => el.type);
            const values4 = response.data.response.averagePlayers?.map((el) => el.avgPlayers);
            const total4 = values4?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

            const labels5 = response.data.response.editionsType?.map((el) => el.creation_date);
            const values5 = response.data.response.editionsType?.map((el) => el.publicBattle);
            const values51 = response.data.response.editionsType?.map((el) => el.publicSurvivor);
            const values6 = response.data.response.editionsType?.map((el) => el.privateBattle);
            const values61 = response.data.response.editionsType?.map((el) => el.privateSurvivor);
            const values9 = response.data.response.editionsType?.map((el) => el.privateStrike);
            const values91 = response.data.response.editionsType?.map((el) => el.publicStrike);
            const totalSurvivor = (values61?.reduce((acc, cur) => acc + (Number(cur) || 0), 0) || 0)
            const totalBattle = (values6?.reduce((acc, cur) => acc + (Number(cur) || 0), 0) || 0)
            const totalStrike = (values9?.reduce((acc, cur) => acc + (Number(cur) || 0), 0) || 0)
            const totals = totalSurvivor + totalBattle + totalStrike

            const labels7 = response.data.response.usersCreatedEditions?.daily.map((el) => el.day);
            const values7 = response.data.response.usersCreatedEditions?.daily.map((el) => el.total);
            const total7 = response.data.response.usersCreatedEditions?.totalPeriod

            const labels8 = response.data.response.usersPlayingPercentage?.map((el) => el.day);
            const values8 = response.data.response.usersPlayingPercentage;

            setDatasetNewPlayers({
                labels: labels0,
                datasets: [
                    {
                        label: "New Players",
                        data: values0,
                        fill: true,
                        borderColor: "rgb(75, 192, 192)",
                        backgroundColor: "rgba(130, 238, 224, 0.4)",
                        tension: 0.4,
                    },
                ],
                total: total0
            });
            setDatasetUsersPlayed({
                labels: labels1,
                datasets: [
                    {
                        label: "Users Played",
                        data: values1,
                        fill: true,
                        borderColor: "rgb(75, 192, 192)",
                        backgroundColor: "rgba(130, 238, 224, 0.4)",
                        tension: 0.4,
                    },
                ],
                total: total1
            });
            setDatasetShippingPlayers({
                labels: labels2,
                datasets: [
                    {
                        label: "Shipping Players",
                        data: values2,
                        fill: true,
                        borderColor: "rgb(75, 192, 192)",
                        backgroundColor: "rgba(130, 238, 224, 0.4)",
                        tension: 0.4,
                    },
                ],
                total: total2
            });
            setDatasetShippedItems({
                labels: labels3,
                datasets: [
                    {
                        label: "Shipped Items",
                        data: values3,
                        fill: true,
                        borderColor: "rgb(75, 192, 192)",
                        backgroundColor: "rgba(130, 238, 224, 0.4)",
                        tension: 0.4,
                    },
                ],
                total: total3
            });
            setDatasetAvgPlayers({
                labels: labels4,
                datasets: [
                    {
                        label: "Avg Players",
                        data: values4,
                        fill: true,
                        borderColor: [
                            "rgb(75, 192, 192)",
                            "rgba(121, 0, 0, 1)"
                        ],
                        backgroundColor: [
                            "rgba(130, 238, 224, 0.4)",
                            "rgba(252, 224, 100, 0.71)",
                        ],
                        tension: 0.4,
                    },
                ],
                total: total4
            });
            setDatasetEditionsType({
                labels: labels5,
                datasets: [
                    {
                        label: "publicBattle",
                        data: values5,
                        fill: true,
                        borderColor: [
                            "rgba(252, 224, 100, 0.71)",
                        ],
                        backgroundColor: [
                            "rgba(130, 238, 224, 0.4)",
                        ],
                        tension: 0.4,
                    },
                    {
                        label: "publicSurivor",
                        data: values51,
                        fill: true,
                        borderColor: [
                            "rgba(252, 224, 100, 0.71)",
                        ],
                        backgroundColor: [
                            "rgba(252, 224, 100, 0.71)",
                        ],
                        tension: 0.4,
                    },
                    {
                        label: "privateBattle",
                        data: values6,
                        fill: true,
                        borderColor: [
                            "rgba(7, 226, 255, 1)"
                        ],
                        backgroundColor: [
                            "rgba(100, 222, 252, 0.71)",
                        ],
                        tension: 0.4,
                    },
                    {
                        label: "privateSurvivor",
                        data: values61,
                        fill: true,
                        borderColor: [
                            "rgba(255, 7, 7, 1)"
                        ],
                        backgroundColor: [
                            "rgba(252, 100, 100, 0.71)",
                        ],
                        tension: 0.4,
                    },
                                        {
                        label: "privateStrike",
                        data: values9,
                        fill: true,
                        borderColor: [
                            "rgb(7, 255, 61)"
                        ],
                        backgroundColor: [
                            "rgba(100, 252, 103, 0.71)",
                        ],
                        tension: 0.4,
                    },
                                        {
                        label: "publicStrike",
                        data: values91,
                        fill: true,
                        borderColor: [
                            "rgba(255, 7, 7, 1)"
                        ],
                        backgroundColor: [
                            "rgba(100, 252, 133, 0.71)",
                        ],
                        tension: 0.4,
                    },
                ],
                total: totals,
                totalSurvivor: totalSurvivor,
                totalBattle: totalBattle,
                totalStrike: totalStrike
            });
            setDatasetUserEditions({
                labels: labels7,
                datasets: [
                    {
                        label: "Users Admin",
                        data: values7,
                        fill: true,
                        borderColor: "rgb(75, 192, 192)",
                        backgroundColor: "rgba(130, 238, 224, 0.4)",
                        tension: 0.4,
                    },
                ],
                total: total7
            });
            setDatasetUserPlayPercentage({
                labels: labels8,
                datasets: [
                    {
                        label: "Percentage Users Played",
                        data: values8.map(item => ({
                            x: item.day,
                            y: item.perc_users_played,
                            value: item.value,
                            league: item.league
                        })),
                        fill: false,
                        borderColor: "rgb(75, 192, 192)",
                        backgroundColor: "rgba(130, 238, 224, 0.4)",
                        tension: 0.3,
                    },
                ]
            });


        } catch (error) {
            toast.error('Qualcosa è andato storto')
        } finally {
            setLoading(false);
        }
    };

    return (
        <div >
            <div className="flex" style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }}>
                <div style={{ color: 'white', textAlign: 'center', placeItems: 'center', width: '40%', marginRight: 'auto', marginLeft: 'auto' }}>

                    <div style={{ color: 'white', textAlign: 'right' }}>Da:</div>
                    <DatePicker
                        selected={dateFrom.toDate()}
                        onChange={(date) => setDateFrom(dayjs(date))}
                        dateFormat="dd/MM/yyyy"
                        popperPlacement="bottom"
                        popperModifiers={[
                            {
                                name: 'arrow',
                                options: {
                                    padding: 24,
                                },
                            },
                        ]}
                    />
                </div>
                <div style={{ color: 'white', textAlign: 'center', placeItems: 'center', width: '40%', marginLeft: 'auto', marginRight: 'auto' }}>

                    <div style={{ color: 'white', textAlign: 'right' }}>A:</div>
                    <DatePicker
                        selected={dateTo.toDate()}
                        onChange={(date) => setDateTo(dayjs(date))}
                        minDate={new Date(dateFrom)}
                        dateFormat="dd/MM/yyyy"
                        popperPlacement="bottom"
                        popperModifiers={[
                            {
                                name: 'arrow',
                                options: {
                                    padding: 24,
                                },
                            },
                        ]} />
                </div>
            </div>
            <div className="graph_container" style={{ marginTop: '20px' }}>
                {window.innerWidth < 1000 && <div style={{ minHeight: '30px', width: '100%' }}></div>}
                <HorizontalBarChart data={datasetNewPlayers} title={'Nuovi utenti: ' + datasetNewPlayers.total} />
                {window.innerWidth < 1000 && <div style={{ minHeight: '30px', width: '100%' }}></div>}
                <HorizontalBarChart data={datasetUsersPlayed} title={'Utenti con almeno una giocata: ' + datasetUsersPlayed.total} />
                <div style={{ minHeight: '50px', width: '100%' }}></div>
                <HorizontalBarChart data={datasetShippingPlayers} title={'Utenti con almeno un acquisto: ' + datasetShippingPlayers.total} />
                {window.innerWidth < 1000 && <div style={{ minHeight: '30px', width: '100%' }}></div>}
                <HorizontalBarChart data={datasetShippedItems} title={'Oggetti acquistati: ' + datasetShippedItems.total} />
                {window.innerWidth < 1000 && <div style={{ minHeight: '30px', width: '100%' }}></div>}
                <HorizontalBarChart data={datasetAvgPlayers} title={'Media partecipanti'} horizontal='x' />
                {window.innerWidth < 1000 && <div style={{ minHeight: '30px', width: '100%' }}></div>}
                {/* <PieChart data={datasetEditionsType} title={'Edizioni: ' + datasetEditionsType.total} />*/}
                <HorizontalBarChart data={datasetEditionsType}
                    title={'Leghe create: ' + datasetEditionsType.total + ' (Survivor: ' + datasetEditionsType.totalSurvivor + ' SkillBattle: ' + datasetEditionsType.totalBattle + ' Strike: ' + datasetEditionsType.totalStrike + ')'} />
                {window.innerWidth < 1000 && <div style={{ minHeight: '30px', width: '100%' }}></div>}
                <HorizontalBarChart data={datasetUserEditions} title={'Utenti creatori di una lega: ' + datasetUserEditions.total} left={true} />
                {window.innerWidth < 1000 && <div style={{ minHeight: '30px', width: '100%' }}></div>}
                <LineChart data={datasetUserPlayPercentage} title={'Percentuale utenti che scelgono'} />
                <div style={{ minHeight: '200px', width: '100%' }}></div>
                {/*    <HorizontalBarChart data={datasetShipping} title={'Shipping'} />*/}
            </div>
        </div>
    );
}
